interface DataType {
   id: number;
   page: string;
   avatar: string;
   rating?: string;
   title: string;
   designation: string;
   desc: string;
};

const testimonial_data: DataType[] = [
   {
      id: 1,
      page: "home_2",
      avatar: "/assets/img/instructor/h2_instructor01.png",
      rating: "(4.8 Ratings)",
      title: "Olivia Mia",
      designation: "Web Design",
      desc: "SkillGro The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested.",
   },
   {
      id: 2,
      page: "home_2",
      avatar: "/assets/img/instructor/h2_instructor02.png",
      rating: "(4.8 Ratings)",
      title: "William Hope",
      designation: "Digital Marketing",
      desc: "SkillGro The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested.",
   },
   {
      id: 3,
      page: "home_2",
      avatar: "/assets/img/instructor/h2_instructor03.png",
      rating: "(4.8 Ratings)",
      title: "Olivia Mia",
      designation: "Web Design",
      desc: "SkillGro The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested.",
   },
   {
      id: 4,
      page: "home_2",
      avatar: "/assets/img/instructor/h2_instructor04.png",
      rating: "(4.8 Ratings)",
      title: "Mark Jukarberg",
      designation: "UX Design Lead",
      desc: "SkillGro The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested.",
   },
   {
      id: 5,
      page: "home_2",
      avatar: "/assets/img/instructor/h2_instructor05.png",
      rating: "(4.8 Ratings)",
      title: "David Millar",
      designation: "UX/UI Design",
      desc: "SkillGro The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested.",
   },
   {
      id: 6,
      page: "home_2",
      avatar: "/assets/img/instructor/h2_instructor03.png",
      rating: "(4.8 Ratings)",
      title: "Olivia Mia",
      designation: "Web Design",
      desc: "SkillGro The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested.",
   },
   {
      id: 7,
      page: "home_2",
      avatar: "/assets/img/instructor/h2_instructor04.png",
      rating: "(4.8 Ratings)",
      title: "Mark Jukarberg",
      designation: "UX Design Lead",
      desc: "SkillGro The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested.",
   },
   {
      id: 1,
      page: "home_3",
      avatar: "/assets/img/others/testi_author01.png",
      rating: "(4.8 Ratings)",
      title: "Wade Warren",
      designation: "Designer",
      desc: "“ when an unknown printer took alley ffferer area typey and scrambled to make a type specimen book hass”",
   },
   {
      id: 2,
      page: "home_3",
      avatar: "/assets/img/others/testi_author02.png",
      title: "Jenny Wilson",
      designation: "Designer",
      desc: "“ when an unknown printer took alley ffferer area typey and scrambled to make a type specimen book hass”",
   },
   {
      id: 3,
      page: "home_3",
      avatar: "/assets/img/others/testi_author03.png",
      title: "Kristin Watson",
      designation: "Designer",
      desc: "“ when an unknown printer took alley ffferer area typey and scrambled to make a type specimen book hass”",
   },
   {
      id: 4,
      page: "home_3",
      avatar: "/assets/img/others/testi_author02.png",
      title: "Jenny Wilson",
      designation: "Designer",
      desc: "“ when an unknown printer took alley ffferer area typey and scrambled to make a type specimen book hass”",
   },
];

export default testimonial_data;